var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'mobile-app': _vm.isMobile, 'pc-app': _vm.isPC },attrs:{"id":"app"}},[(_vm.isPC)?_c('PcHeader'):_c('MobileHeader'),_c('keep-alive',[_c('router-view')],1),(_vm.isPC)?_c('PcFooter'):_c('MobileFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }